(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([
            '../env'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('../env')
        );
    }
})(this, function (env){
    return env.createDatasourceEnv;
});